import { store } from '../redux/store';

const objectTranslation = require('../translations/foundObjects.translation');

const prepareDateWithZero = (element) => {
  return `${element >= 10 ? element : `0${element}`}`;
};

export const formatDate = (date) => {
  const time = `${prepareDateWithZero(date.getHours())}:${prepareDateWithZero(date.getMinutes())}`;
  const dateStr = `${prepareDateWithZero(date.getDate())}.${prepareDateWithZero(date.getMonth() + 1)}.${date.getFullYear()}`;
  return `${dateStr} ${time}`;
};

export const formatDateForUrl = (date) => {
  const time = `${prepareDateWithZero(date.getHours())}:${prepareDateWithZero(date.getMinutes())}`;
  const dateStr = `${prepareDateWithZero(date.getDate())}.${prepareDateWithZero(date.getMonth() + 1)}.${date.getFullYear()}`;
  return `${dateStr}-${time}`;
};

export const getCurrentLanguage = () => {
  const { user } = store.getState().root.userStore;
  return user?.locale?.split(/[-_]/)[0] || navigator.language.split(/[-_]/)[0];
};

export const calculateObjectsTypes = (objects, locale, template) => {
  if (objects?.length) {
    const resultObj = {};
    const resultArr = [];

    for (const object of objects) {
      const translatedType = objectTranslation[locale]?.[object.type] || object.type;

      if (object.count !== undefined) {
        if (resultObj[translatedType]) {
          resultObj[translatedType] += object.count;
        } else {
          resultObj[translatedType] = object.count;
        }
      } else if (resultObj[translatedType]) {
        resultObj[translatedType] += 1;
      } else {
        resultObj[translatedType] = 1;
      }
    }

    for (const [key, value] of Object.entries(resultObj)) {
      resultArr.push({
        type: key,
        count: value,
      });
    }

    return resultArr;
  } else {
    if (!objects && template) {
      return [{
        type: template.name,
        count: -1,
      }];
    } else if (template) {
      return [{
        type: template.name,
        count: 0,
      }];
    }
    return [];
  }
};
